import Loading from '../components/Loading';
import React from 'react';
import UserProfile from '../components/UserProfile';
import { IProfileResponse } from '../model/ProfileResponse';
import authService from '../services/auth';

export const context = 'userProfile';

interface IUserProfileRouteState {
    error?: string;
    isLoading: boolean;
    email?: string;
}

export class UserProfileRoute extends React.Component<{}, IUserProfileRouteState> {
    state = {
        email: undefined,
        error: undefined,
        isLoading: true,
    };

    async componentDidMount() {
        try {
            const res: IProfileResponse = await authService.getUserInfo();
            const { data } = res;

            if (data !== undefined) {
                this.setState({
                    email: data.email,
                    isLoading: false,
                });
            }
        } catch (error) {
            this.setState({ error: (error as Error).message });
        }
    }

    render() {
        const { error, isLoading } = this.state;
        if (error) {
            throw error;
        }

        if (isLoading) {
            return <Loading />;
        }

        return <UserProfile context={context} />;
    }
}

export default UserProfileRoute;
